import { LitElement } from 'lit';
import { SettingsChangeEvent } from '../types';

export function dispatchSettingsUpdate(settingsChangeEvent: SettingsChangeEvent, ctx: LitElement) {
    const event = new CustomEvent<SettingsChangeEvent>('on-change-value', {
        detail: settingsChangeEvent,
        bubbles: true,  // they need to bubble because they are sometimes rendered inside a slot
        composed: true
    });
    
    ctx.dispatchEvent(event);
}